var log = {exports: {}};

export { log as l };
